import { LocationNodeData } from '../../../../@types';

export enum SearchParams {
  ParentId = 'parentId',
  ParentName = 'parentName',
  NodeTypeCode = 'nodeTypeCode',
  PreferedNodeType = 'preferedNodeType',
  ClientId = 'clientId',
  ContractId = 'contractId',
  BrandId = 'brandId'
}

export interface SelectedParentType {
  id: number;
  name: string;
  nodeTypeCode: string;
  isFromLiveSearch?: boolean;
}

export interface ClientCustomerAddEditStructureProps {
  structureId?: string;
  locationType?: string;
  defaultClientId?: string;
  defaultContractId?: string;
  defaultBrandId?: string;
  pageType?: string;
  locationText?: string;
  mainLocationNode?: LocationNodeData;
  setSubLocationNode?: ((locationNode?: LocationNodeData) => void) | undefined;
  setMainLocationNode?: ((locationNode?: LocationNodeData) => void) | undefined;
  setLocationText?: (locationtext: string) => void;
  setOpenLocationCreateUpdatePopup?: (isOpen: boolean) => void;
  onSetCreatedLocation?: (createdLocationId: number) => void;
}